<style lang="scss" scoped>
.full-width {
  width: 100%;
}
</style>
<template>
  <div>
    <v-row>
      <div class="mb-4">
        <label class="body-1">Roles</label>
      </div>
      <v-spacer></v-spacer>
      <span class="mr-4 mt-0" v-show="isValid">
        <anchor-tooltip-btn
          small
          left
          icon="mdi-plus"
          is-icon
          tooltip="Assign a new role"
          color="primary"
          :id="`user-role-add-btn`"
          :disabled="!isValid"
          @click="() => addRole()"
        />
      </span>
    </v-row>
    <v-row>
      <div class="full-width" v-for="(role, idx) in items" :key="idx">
        <v-divider v-if="idx !== 0" class="mb-4" />
        <v-row>
          <v-col class="py-0">
            <v-autocomplete
              label="Role"
              outlined
              dense
              :disabled="loading"
              :rules="rules.role"
              :items="roleLevels"
              item-text="name"
              item-value="_id"
              v-model="role.role_level_id"
            />
          </v-col>
          <v-col cols="1" class="py-0 d-flex">
            <span class="ml-0 mt-2">
              <anchor-tooltip-btn
                small
                left
                is-icon
                v-if="items.length > 1 && idx != 0"
                icon="mdi-trash-can-outline"
                tooltip="Unassign Role"
                color="secondary"
                :id="`user-role-${idx}-remove-btn`"
                @click="() => unassignRole(idx)"
              />
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0 pl-4">
            <domain-selection
              v-if="!loading"
              :items="domains"
              v-model="role.domains"
              :chunk="7"
            ></domain-selection>
            <v-skeleton-loader
              v-else
              type="table-row@4"
              max-width="3000"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </div>
    </v-row>
  </div>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import DomainSelection from './DomainSelection';
import RULES from './resources/rules';

export default {
  components: {
    DomainSelection,
  },
  props: {
    value: {},
  },
  data: () => ({
    active: [],
    open: [],
    domains: [],
    roleLevels: [],
    rules: RULES,
    loading: true,
  }),
  computed: {
    items() {
      const items = [];
      if (this.value.length === 0) {
        const newRole = this.addRole();
        items.push(newRole);
      }
      return items.concat(this.value);
    },
    isValid() {
      return this.value.every(role => role.role_level_id !== undefined);
    },
  },
  methods: {
    addRole() {
      const updatedValue = this.value.concat([{}]);
      this.$emit('input', updatedValue);
      return updatedValue;
    },
    unassignRole(idx) {
      if (this.value.length > 1) {
        const tmp = this.$utils.deepCopy(this.value);
        tmp.splice(idx, 1);
        this.$emit('input', tmp);
        this.loading = true;
        this.$nextTick(() => {
          this.loading = false;
        });
      }
    },
    getData(path, dataName, compareFn) {
      this.$requests
        .get(`/v1/${path}`)
        .then(response => {
          this.loading = true;
          const items = response.data.sort(compareFn);
          this[dataName] = items;
        })
        .catch(() => {
          this.$toast.error(`Could not resolve ${dataName}...`, { timeout: 3000 });
          this.error = true;
        })
        .then(() => {
          this.loading = false;
        });
    },
    sortLevel(levelA, levelB) {
      const levelAField = levelA.role.title + levelA.name;
      const levelBField = levelB.role.title + levelB.name;
      return levelAField < levelBField ? -1 : 1;
    },
    sortDomain(domainA, domainB) {
      return domainA.name < domainB.name ? -1 : 1;
    },
  },
  mounted() {
    this.getData('role_levels', 'roleLevels', this.sortLevel);
    this.getData('domains', 'domains', this.sortDomain);
  },
};
</script>
